import { useState } from "react";
import { Copy, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export default function PinConfirm({ open, onOpenChange, title = "Konfirmasi PIN", description, highlight, copyValue, confirmLabel = "Konfirmasi", destructive = false, onConfirm, testid = "pin-confirm" }) {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  const close = (v) => { setPin(""); onOpenChange(v); };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/verify-pin", { pin });
      close(false);
      await onConfirm(pin);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent data-testid={`${testid}-dialog`}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="w-5 h-5 text-primary" /> {title}</DialogTitle>
          <DialogDescription className="sr-only">Verifikasi PIN untuk melanjutkan aksi</DialogDescription>
        </DialogHeader>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
        {highlight && (
          <div className="rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-center">
            <div className="text-[10px] uppercase tracking-widest text-amber-600 font-semibold">Cocokkan nominal transfer di mutasi bank</div>
            <div className="flex items-center justify-center gap-2">
              <div className="text-3xl font-extrabold font-mono text-amber-600" data-testid={`${testid}-highlight`}>{highlight}</div>
              {copyValue && (
                <button type="button"
                  onClick={async () => { try { await navigator.clipboard.writeText(copyValue); toast.success(`Nominal ${copyValue} disalin`); } catch { toast.error("Gagal menyalin"); } }}
                  className="inline-flex items-center gap-1 rounded-lg bg-amber-500/20 hover:bg-amber-500/30 text-amber-700 text-xs font-semibold px-2.5 py-1.5 transition-colors"
                  data-testid={`${testid}-btn-copy`}>
                  <Copy className="w-3.5 h-3.5" /> Salin
                </button>
              )}
            </div>
          </div>
        )}
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1.5">
            <Label>PIN Anda (wajib untuk melanjutkan)</Label>
            <Input type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} required placeholder="Masukkan PIN" autoFocus data-testid={`${testid}-input-pin`} />
          </div>
          <Button type="submit" variant={destructive ? "destructive" : "default"} className="w-full" disabled={busy} data-testid={`${testid}-btn-submit`}>
            {busy ? "Memverifikasi..." : confirmLabel}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
